import React from 'react';

export default function Hero() {
  return (
    <div 
      id="hero" 
      className="text-white py-5 d-flex align-items-center position-relative overflow-hidden" 
      style={{ 
        minHeight: '85vh', 
        background: 'linear-gradient(145deg, #0f4cba 0%, #062a75 100%)' 
      }}
    >
      {/* Decorative Background Elements */}
      <div 
        className="position-absolute rounded-circle opacity-10 bg-white" 
        style={{ width: '400px', height: '400px', top: '-10%', right: '-5%', filter: 'blur(50px)' }}
      ></div>
      <div 
        className="position-absolute rounded-circle opacity-10 bg-warning" 
        style={{ width: '300px', height: '300px', bottom: '5%', left: '-5%', filter: 'blur(60px)' }}
      ></div>

      <div className="container position-relative z-1">
        <div className="row align-items-center g-5">
          
          {/* Left Column: Core Messaging */}
          <div className="col-lg-7 text-center text-lg-start">
            <div className="d-inline-flex align-items-center gap-2 bg-white bg-opacity-10 border border-white border-opacity-25 rounded-pill px-3 py-1.5 mb-4 shadow-sm">
              <span className="badge bg-warning text-dark rounded-pill fw-bold px-2 py-1">ISO 9001:2008</span>
              <span className="text-white small fw-semibold">Certified National Organization</span>
            </div>
            
            <h1 className="display-3 fw-extrabold mb-3 tracking-tight lh-sm">
              Nation Building <br className="d-none d-md-inline" />
              <span className="text-warning">is Our Oath</span>
            </h1>
            
            <p className="lead text-white-50 mb-4 fs-4 fw-light" style={{ maxWidth: '650px' }}>
              Established on February 12, 1996, SOCIETY FOR THE "WATER" (SFW) is one of India's fastest-growing skill development architectures—transforming communities through planned, sustainable employment pipelines.
            </p>
            
            {/* Action Buttons */}
            <div className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-3 mb-5">
              <a href="#about" className="btn btn-light btn-lg px-4 py-3 fw-bold text-primary shadow-sm hover-up">
                Explore Our Focus <i className="bi bi-arrow-right ms-1"></i>
              </a>
              <a href="#projects" className="btn btn-outline-light btn-lg px-4 py-3 fw-semibold bg-blue bg-opacity-5">
                <i className="bi bi-geo-alt me-1"></i> National Footprint
              </a>
            </div>

            {/* Verification Metadata Tags */}
            <div className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-4 border-top border-white border-opacity-10 pt-4 text-white-70 small">
              <div className="d-flex align-items-center bg-dark bg-opacity-20 px-3 py-2 rounded border border-white border-opacity-5">
                <i className="bi bi-bank text-warning me-2 fs-5"></i>
                <div>
                  <div className="text-white-50 extra-small font-monospace">VERIFIED REGISTRATION</div>
                  <strong className="text-white">Ministry of Home Affairs</strong>
                </div>
              </div>
              <div className="d-flex align-items-center bg-dark bg-opacity-20 px-3 py-2 rounded border border-white border-opacity-5">
                <i className="bi bi-file-earmark-text text-info me-2 fs-5"></i>
                <div>
                  <div className="text-white-50 extra-small font-monospace">FINANCIAL STATUS</div>
                  <strong className="text-white">Regd. with Income Tax</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Dynamic Impact Showcase */}
          <div className="col-lg-5">
            <div className="card border-0 rounded-4 shadow-lg p-4 bg-white bg-opacity-10 backdrop-blur" style={{ backdropFilter: 'blur(15px)', border: '1px solid rgba(255,255,255,0.15)' }}>
              <div className="card-body p-2">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <h5 className="fw-bold text-white mb-0 text-uppercase tracking-wider font-monospace small">Empowerment Registry</h5>
                  <span className="pulse-indicator"></span>
                </div>
                
                {/* Micro Stat Card 1 */}
                <div className="d-flex align-items-center bg-white bg-opacity-10 rounded-3 p-3 mb-3 border border-white border-opacity-10">
                  <div className="bg-warning rounded p-2 text-dark me-3">
                    <i className="bi bi-people-fill fs-3"></i>
                  </div>
                  <div>
                    <h3 className="fw-bold mb-0 text-white font-monospace">27,604+</h3>
                    <p className="text-white-50 small mb-0">Unprivileged Youth Trained</p>
                  </div>
                </div>

                {/* Micro Stat Card 2 */}
                <div className="d-flex align-items-center bg-white bg-opacity-10 rounded-3 p-3 mb-3 border border-white border-opacity-10">
                  <div className="bg-info rounded p-2 text-white me-3">
                    <i className="bi bi-check-circle-fill fs-3"></i>
                  </div>
                  <div>
                    <h3 className="fw-bold mb-0 text-white font-monospace">19,570+</h3>
                    <p className="text-white-50 small mb-0">Verified Career Placements</p>
                  </div>
                </div>

                {/* Micro Stat Card 3 */}
                <div className="d-flex align-items-center bg-white bg-opacity-10 rounded-3 p-3 border border-white border-opacity-10">
                  <div className="bg-success rounded p-2 text-white me-3">
                    <i className="bi bi-graph-up-arrow fs-3"></i>
                  </div>
                  <div>
                    <h3 className="fw-bold mb-0 text-white font-monospace">₹46.97 Cr</h3>
                    <p className="text-white-50 small mb-0">Cumulative Infrastructure Scale</p>
                  </div>
                </div>
                
                <div className="text-center mt-4">
                  <small className="text-white-50 font-italic">
                    <i className="bi bi-shield-fill-check text-warning me-1"></i> Supporting SC, ST, OBC & Minorities ecosystems.
                  </small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      {/* Dynamic pulse CSS injected helper */}
      <style>{`
        .extra-small { font-size: 0.7rem; letter-spacing: 0.5px; }
        .pulse-indicator {
          width: 10px; height: 10px; background: #00ff88; border-radius: 50%;
          box-shadow: 0 0 0 0 rgba(0, 255, 136, 0.7); animation: pulse 1.8s infinite;
        }
        @keyframes pulse {
          0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(0, 255, 136, 0.7); }
          70% { transform: scale(1); box-shadow: 0 0 0 8px rgba(0, 255, 136, 0); }
          100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(0, 255, 136, 0); }
        }
        .hover-up:hover { transform: translateY(-3px); transition: all 0.2s ease-in-out; }
      `}</style>
    </div>
  );
}